import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FaArrowLeft,
  FaCheckCircle,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaMobileAlt, FaLaptopCode, FaGift, FaCashRegister, FaBrain,
  FaRobot, FaServer, FaPaintBrush, FaShoppingCart, FaShieldAlt,
} from 'react-icons/fa';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';
import './ServicePage.css';

const serviceDetails = {
  'mobile-apps': {
    icon: <FaMobileAlt />,
    color: '#7ab934',
    title: 'Mobile App Development',
    tagline: 'Android & iOS — built for every phone and tablet',
    description: `We build custom mobile applications for Android and iOS platforms. Whether you need a simple customer-facing app or a complex enterprise solution, we develop it using Flutter so your app looks and works great on every phone and tablet. We handle everything — from the first sketch to app store submission. Any idea you have, any feature you need, we build it exactly as you want. We also make sure your app works perfectly on tablets, with layouts designed for larger screens.`,
    images: [
      // q set
      '/images/softwware/q1.jpeg',
      '/images/softwware/q2.jpeg',
      '/images/softwware/q3.jpeg',
      '/images/softwware/q4.jpeg',
      '/images/softwware/q5.jpeg',
      '/images/softwware/q6.jpeg',
      '/images/softwware/q7.jpeg',
      '/images/softwware/q8.jpeg',
      '/images/softwware/q9.jpeg',
      '/images/softwware/q10.jpeg',
      '/images/softwware/q11.jpeg',
      '/images/softwware/q12.jpeg',
      '/images/softwware/q13.jpeg',
      // a set
      '/images/softwware/a1.jpeg',
      '/images/softwware/a2.jpeg',
      '/images/softwware/a3.jpeg',
      '/images/softwware/a4.jpeg',
      '/images/softwware/a5.jpeg',
      '/images/softwware/a6.jpeg',
      '/images/softwware/a7.jpeg',
      '/images/softwware/a8.jpeg',
      '/images/softwware/a10.jpeg',
      // x set
      '/images/softwware/x1.jpeg',
      '/images/softwware/x2.jpeg',
      '/images/softwware/x3.jpeg',
      '/images/softwware/x4.jpeg',
      '/images/softwware/x5.jpeg',
      '/images/softwware/x6.jpeg',
      // WhatsApp set
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.02 PM.jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.02 PM (1).jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.02 PM (2).jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.03 PM.jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.03 PM (1).jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.06 PM.jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.07 PM.jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.07 PM (1).jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.08 PM.jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.08 PM (1).jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.08 PM (2).jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.09 PM.jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.09 PM (1).jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 2.00.09 PM (2).jpeg',
      '/images/softwware/WhatsApp Image 2026-04-13 at 3.25.38 PM (3).jpeg',
      // e set
      '/images/softwware/e1.jpeg',
      '/images/softwware/e2.jpeg',
      '/images/softwware/e3.jpeg',
      '/images/softwware/e4.jpeg',
      '/images/softwware/e5.jpeg',
      '/images/softwware/e6.jpeg',
      '/images/softwware/e7.jpeg',
      '/images/softwware/e8.jpeg',
      '/images/softwware/e9.jpeg',
      // r set
      '/images/softwware/r1.jpeg',
      '/images/softwware/r2.jpeg',
      '/images/softwware/r3.jpeg',
      // s set
      '/images/softwware/s1.jpeg',
      '/images/softwware/s2.jpeg',
      // w set
      '/images/softwware/w1.jpeg',
      '/images/softwware/w2.jpeg',
      '/images/softwware/w3.jpeg',
      '/images/softwware/w4.jpeg',
      '/images/softwware/w5.jpeg',
      '/images/softwware/w6.jpeg',
      '/images/softwware/w7.jpeg',
      '/images/softwware/w8.jpeg',
      '/images/softwware/w9.jpeg',
      // z set
      '/images/softwware/z1.jpeg',
      '/images/softwware/z2.jpeg',
      // c set
      '/images/softwware/c1.jpeg',
      '/images/softwware/c2.jpeg',
    ],
    whatWeDo: [
      'Android & iOS apps using Flutter — one codebase, two platforms',
      'Tablet-optimized layouts — works great on iPad and Android tablets',
      'Offline-capable apps that continue working without internet',
      'Push notifications and real-time updates for your users',
      'Payment gateway integration (cards, mobile payments)',
      'App Store & Google Play submission — fully handled by us',
    ],
    recentWorks: [
      {
        title: 'FoodRush',
        client: 'Restaurant Chain — Colombo',
        desc: 'Online food ordering app with real-time order tracking, delivery zones, and Stripe payment integration. Works on phones and tablets.',
        tags: ['Flutter', 'Firebase', 'Stripe'],
      },
      {
        title: 'MedBook',
        client: 'Private Healthcare Group',
        desc: 'Doctor appointment booking app for Android and iOS with patient history, prescription records, and appointment reminders.',
        tags: ['Flutter', 'Node.js', 'PostgreSQL'],
      },
      {
        title: 'ShopTrack',
        client: 'Retail Chain — Sri Lanka',
        desc: 'Inventory and sales tracking mobile app with a full tablet layout designed for in-store staff — managing thousands of products.',
        tags: ['React Native', 'Laravel', 'MySQL'],
      },
    ],
  },

  'web-applications': {
    icon: <FaLaptopCode />,
    color: '#3b82f6',
    title: 'Web Applications',
    tagline: 'Fast, beautiful websites and online systems',
    description: `We build everything from simple landing pages to full-featured web platforms. Our websites load fast, look great on any screen size, and are built to grow with your business. Whether you need a company website, a customer portal, or a complex internal system — we design, build, and launch it. Every site we build is optimized for search engines so more people can find you online.`,
    images: [
      '/images/mockups/web1.svg',
      '/images/mockups/web2.svg',
      '/images/mockups/web3.svg',
    ],
    desktopImages: [
      '/images/mockups/web-d1.svg',
      '/images/mockups/web-d2.svg',
      '/images/mockups/web-d3.svg',
      '/images/mockups/web-d4.svg',
      '/images/mockups/web-d5.svg',
      '/images/mockups/web-d6.svg',
      '/images/mockups/web-d7.svg',
    ],
    whatWeDo: [
      'Company websites and professional business landing pages',
      'Customer-facing portals, dashboards, and booking systems',
      'Internal management systems (ERP, CRM, admin panels)',
      'Progressive Web Apps (PWA) — works like an app on mobile',
      'Multi-language and multi-currency support for global reach',
      'SEO optimization included in every project we deliver',
    ],
    recentWorks: [
      {
        title: 'Ceylons Travel',
        client: 'Tourism Company — Sri Lanka',
        desc: 'Full tourism website with tour packages, online booking forms, photo galleries, and payment integration.',
        tags: ['React', 'Node.js', 'MongoDB'],
      },
      {
        title: 'Lanka Realty Portal',
        client: 'Real Estate Agency',
        desc: 'Property listing and agent management platform with map integration, advanced filtering, and agent dashboard.',
        tags: ['Next.js', 'PostgreSQL', 'Google Maps'],
      },
      {
        title: 'EduPort LMS',
        client: 'Online Education Provider',
        desc: 'Full learning management system with video streaming, quizzes, certificates, and student progress tracking.',
        tags: ['React', 'Laravel', 'MySQL'],
      },
    ],
  },

  'loyalty-reward': {
    icon: <FaGift />,
    color: '#ec4899',
    title: 'Loyalty & Reward Systems',
    tagline: 'Keep your customers coming back, again and again',
    description: `The best way to keep your customers coming back is to make them feel valued — and that's exactly what our loyalty systems do. Every customer gets their own unique QR code. They scan it at your counter to earn points with every purchase and watch their rewards grow. On their mobile app, customers can see their loyalty points, check available portions and offers, and redeem rewards whenever they want.\n\nOn your side, you get a powerful Admin Panel — available as both a web dashboard and a mobile admin app — so you can manage customers, view point balances, create promotions, and track everything from anywhere. Whether you run a café, restaurant, retail store, or a chain of branches, this system keeps your customers engaged and coming back.`,
    images: [
      '/images/softwware/q1.jpeg',
      '/images/softwware/q2.jpeg',
      '/images/softwware/q3.jpeg',
      '/images/softwware/q4.jpeg',
      '/images/softwware/q5.jpeg',
      '/images/softwware/q6.jpeg',
      '/images/softwware/q7.jpeg',
      '/images/softwware/q8.jpeg',
      '/images/softwware/q9.jpeg',
      '/images/softwware/q10.jpeg',
      '/images/softwware/q11.jpeg',
      '/images/softwware/q12.jpeg',
      '/images/softwware/q13.jpeg',
    ],
    whatWeDo: [
      'Unique QR code for every customer — scan to earn points instantly',
      'Customer mobile app — view loyalty points, portions, and available rewards',
      'Admin Panel (web & mobile) — manage customers, promotions, and point balances',
      'Points-based and stamp-based reward programs',
      'Birthday rewards and automated promotional offers',
      'Tier-based membership (Silver, Gold, Platinum levels)',
      'Multi-branch support for chains and franchise businesses',
      'Analytics dashboard to understand your customers better',
    ],
    recentWorks: [
      {
        title: 'Star Rewards',
        client: 'Coffee Shop Chain — Colombo',
        desc: 'Digital stamp loyalty app — customers scan a QR code to collect stamps and redeem free drinks after 10 visits.',
        tags: ['Flutter', 'Firebase', 'QR Code'],
      },
      {
        title: 'VIPCard',
        client: 'Supermarket Group — Sri Lanka',
        desc: 'Points loyalty system with birthday bonuses, tiered membership levels, and an admin dashboard for staff.',
        tags: ['React Native', 'Node.js', 'MySQL'],
      },
      {
        title: 'LoyaltyHub',
        client: 'Multi-store Retail Group',
        desc: 'Centralized rewards platform shared across 12 store locations with unified customer accounts and point balances.',
        tags: ['Flutter', 'Laravel', 'PostgreSQL'],
      },
    ],
  },

  'pos-systems': {
    icon: <FaCashRegister />,
    color: '#f59e0b',
    title: 'POS Systems',
    tagline: 'Smart billing and sales management — built for your business',
    description: `Our POS (Point of Sale) systems make billing fast, simple, and accurate. Built for shops, restaurants, cafés, pharmacies, and any business that handles sales. Manage your stock, print receipts, track daily income, and generate reports — all from one screen. Our systems work on tablets, touchscreens, and regular computers, and you can check your sales from anywhere.`,
    images: [
      '/images/mockups/pos1.svg',
      '/images/mockups/pos2.svg',
      '/images/mockups/pos3.svg',
    ],
    desktopImages: [
      '/images/mockups/pos-d1.svg',
      '/images/mockups/pos-d2.svg',
      '/images/mockups/pos-d3.svg',
      '/images/mockups/pos-d4.svg',
    ],
    whatWeDo: [
      'Touch-screen POS for restaurants, cafés, and retail stores',
      'Inventory and stock management with low-stock alerts',
      'Daily, weekly, and monthly sales reports with charts',
      'Multi-user roles — cashier, manager, and admin access levels',
      'Barcode scanner and thermal receipt printer integration',
      'Cloud sync so you can monitor sales from any device, anywhere',
    ],
    recentWorks: [
      {
        title: 'QuickBill Restaurant POS',
        client: 'Restaurant Chain — Sri Lanka',
        desc: 'Table management, kitchen display screen, and fast billing POS system rolled out across 5 restaurant branches.',
        tags: ['React', 'Node.js', 'MySQL', 'Thermal Printer'],
      },
      {
        title: 'RetailPro',
        client: 'Clothing Store — Colombo',
        desc: 'Barcode-based retail POS with inventory tracking, size and colour variants, and end-of-day sales reports.',
        tags: ['Flutter', 'Laravel', 'Barcode Scanner'],
      },
      {
        title: 'CaféDesk',
        client: 'Café & Bakery — Sri Lanka',
        desc: 'Tablet POS for a busy café with menu management, sales history, cashier shift tracking, and daily summaries.',
        tags: ['React Native', 'Firebase'],
      },
    ],
  },

  'ai-bots': {
    icon: <FaBrain />,
    color: '#8b5cf6',
    title: 'AI Applications & Bots',
    tagline: 'Smart automation that works for your business — 24 hours a day',
    description: `We build AI-powered tools that handle repetitive tasks so your team can focus on what matters. Chatbots that answer customer questions instantly, smart systems that process data automatically, and automation tools that save your staff hours every single day. Built using the latest AI technology and tailored specifically to your business needs.`,
    images: [
      '/images/mockups/ai1.svg',
      '/images/mockups/ai2.svg',
      '/images/mockups/ai3.svg',
    ],
    desktopImages: [
      '/images/mockups/ai-d1.svg',
      '/images/mockups/ai-d2.svg',
      '/images/mockups/ai-d3.svg',
      '/images/mockups/ai-d4.svg',
    ],
    whatWeDo: [
      'Customer service chatbots for WhatsApp, websites, and apps',
      'AI-powered lead qualification and sales bots',
      'Automated FAQ responders trained on your business content',
      'Document processing and data extraction using AI',
      'Product recommendation engines for e-commerce stores',
      'Integration with OpenAI GPT-4, Google Gemini, and custom models',
    ],
    recentWorks: [
      {
        title: 'SupportBot',
        client: 'Telecom Company — Sri Lanka',
        desc: 'WhatsApp chatbot that handles 80% of customer support queries automatically, around the clock — no staff needed overnight.',
        tags: ['OpenAI', 'Twilio', 'Node.js'],
      },
      {
        title: 'LeadGen AI',
        client: 'Real Estate Agency',
        desc: 'AI bot that chats with website visitors, qualifies potential buyers, and automatically books callbacks with agents.',
        tags: ['GPT-4', 'React', 'CRM Integration'],
      },
      {
        title: 'SmartFAQ',
        client: 'Online Retailer',
        desc: 'AI assistant trained on product FAQs and policies — reduced incoming support tickets by 60% in the first month.',
        tags: ['Gemini', 'Firebase', 'Flutter'],
      },
    ],
  },

  'custom-software': {
    icon: <FaRobot />,
    color: '#14b8a6',
    title: 'Custom Software',
    tagline: 'Software built exactly for the way your business works',
    description: `No off-the-shelf software quite fits your business? We build it from scratch, designed entirely around your workflow and processes. From staff management systems to complex enterprise tools — if you can describe it to us, we can build it. We work closely with you step by step so the final product is exactly what your team needs every day.`,
    images: [
      '/images/mockups/custom1.svg',
    ],
    desktopImages: [
      '/images/mockups/custom-d1.svg',
      '/images/mockups/custom-d2.svg',
      '/images/mockups/custom-d3.svg',
      '/images/mockups/custom-d4.svg',
      '/images/mockups/custom-d5.svg',
      '/images/mockups/custom-d6.svg',
    ],
    whatWeDo: [
      'ERP systems to manage your entire business in one place',
      'CRM systems to manage customers and your sales pipeline',
      'HR management — attendance, payroll, leaves, and performance',
      'Warehouse and logistics management software',
      'Business intelligence dashboards and custom reports',
      'School, hospital, and government administration systems',
    ],
    recentWorks: [
      {
        title: 'HRFlow',
        client: 'Manufacturing Company — Sri Lanka',
        desc: 'Complete HR system with fingerprint attendance, automated payroll, leave management, and performance reviews.',
        tags: ['React', 'Laravel', 'MySQL'],
      },
      {
        title: 'StockMaster',
        client: 'Wholesale Distributor',
        desc: 'Warehouse management system tracking over 10,000 products across 3 warehouse locations in real time.',
        tags: ['Next.js', 'Node.js', 'PostgreSQL'],
      },
      {
        title: 'SchoolERP',
        client: 'Private School — Colombo',
        desc: 'Full school management platform covering students, teachers, timetables, fee collection, and a parent portal.',
        tags: ['React', 'Laravel', 'MySQL'],
      },
    ],
  },

  'backend-api': {
    icon: <FaServer />,
    color: '#f97316',
    title: 'Backend & API Systems',
    tagline: 'The powerful engine behind your app or website',
    description: `The backend is the invisible part of your software that makes everything work — storing your data securely, processing payments, connecting your app to other services, and keeping everything running fast. We build robust, scalable backends designed to handle thousands of users without slowing down or breaking, even during your busiest moments.`,
    images: [
      '/images/mockups/backend1.svg',
      '/images/mockups/backend2.svg',
    ],
    desktopImages: [
      '/images/mockups/backend-d1.svg',
      '/images/mockups/backend-d2.svg',
      '/images/mockups/backend-d3.svg',
      '/images/mockups/backend-d4.svg',
      '/images/mockups/backend-d5.svg',
    ],
    whatWeDo: [
      'REST and GraphQL APIs for mobile apps and web platforms',
      'Secure user authentication and role-based access control',
      'Payment gateway integrations — Stripe, PayPal, and local banks',
      'Third-party API integrations — Google, Meta, SMS, and email',
      'Real-time features using WebSockets (live chat, notifications)',
      'Cloud deployment on AWS, DigitalOcean, or your own server',
    ],
    recentWorks: [
      {
        title: 'PayGate API',
        client: 'E-Commerce Platform',
        desc: 'Multi-currency payment API supporting Stripe, PayPal, and local bank transfers — processing thousands of transactions monthly.',
        tags: ['Node.js', 'Stripe API', 'REST API'],
      },
      {
        title: 'DataSync Service',
        client: 'Retail Chain',
        desc: 'Real-time data sync backend connecting POS systems across 8 branches to a central reporting dashboard.',
        tags: ['Node.js', 'WebSocket', 'Redis'],
      },
      {
        title: 'LogiAPI',
        client: 'Courier Company — Sri Lanka',
        desc: 'Delivery tracking backend with driver mobile app API, customer tracking links, and automated SMS delivery updates.',
        tags: ['Laravel', 'MySQL', 'SMS API'],
      },
    ],
  },

  'ui-ux-design': {
    icon: <FaPaintBrush />,
    color: '#06b6d4',
    title: 'UI/UX Design',
    tagline: 'Designs that look stunning and feel effortless to use',
    description: `Great design is what separates a good product from a great one. We design user interfaces that guide people naturally — beautiful visuals, clear layouts, and interactions that feel completely effortless. Every design we produce is based on how real people actually use apps and websites, not just how they look on a screen. We test, refine, and deliver something your users will love.`,
    images: [
      '/images/mockups/uiux1.svg',
      '/images/mockups/uiux2.svg',
    ],
    desktopImages: [
      '/images/mockups/uiux-d1.svg',
      '/images/mockups/uiux-d2.svg',
      '/images/mockups/uiux-d3.svg',
      '/images/mockups/uiux-d4.svg',
      '/images/mockups/uiux-d5.svg',
    ],
    whatWeDo: [
      'Mobile app UI design — pixel-perfect for Android and iOS',
      'Website and web dashboard interface design',
      'User experience (UX) research and user journey mapping',
      'Interactive Figma prototypes — you can feel it before we build it',
      'Design systems and reusable component libraries',
      'Full branding integration — your colors, fonts, and identity',
    ],
    recentWorks: [
      {
        title: 'BankUI Redesign',
        client: 'Regional Bank — Sri Lanka',
        desc: 'Complete redesign of a mobile banking app — cleaner flows, modern visuals. Support calls dropped by 40% after launch.',
        tags: ['Figma', 'UI Design', 'UX Research'],
      },
      {
        title: 'HealthApp UI',
        client: 'Healthcare Startup',
        desc: 'Patient-friendly mobile app design with a full accessibility focus — tested and iterated with real patients.',
        tags: ['Figma', 'Prototyping', 'Accessibility'],
      },
      {
        title: 'Online Store Redesign',
        client: 'Fashion Retailer',
        desc: 'E-commerce website redesign that increased the conversion rate by 28% in the first month after going live.',
        tags: ['Figma', 'UI/UX', 'A/B Testing'],
      },
    ],
  },

  'ecommerce': {
    icon: <FaShoppingCart />,
    color: '#a855f7',
    title: 'E-Commerce Solutions',
    tagline: 'Your online shop — built to sell, built to grow',
    description: `We build online stores that are fast, secure, and designed to turn visitors into buyers. From a simple product catalogue to a full marketplace with multiple sellers — we set up everything: your store, payment system, stock management, and order tracking. Sri Lankan businesses using our e-commerce stores now sell both locally and internationally.`,
    images: [
      '/images/mockups/ecom1.svg',
      '/images/mockups/ecom2.svg',
      '/images/mockups/ecom3.svg',
    ],
    desktopImages: [
      '/images/mockups/ecom-d1.svg',
      '/images/mockups/ecom-d2.svg',
      '/images/mockups/ecom-d3.svg',
      '/images/mockups/ecom-d4.svg',
    ],
    whatWeDo: [
      'Custom e-commerce on Shopify, WooCommerce, or built from scratch',
      'Secure payment integration — cards, PayPal, and local gateways',
      'Product management with categories, variants, and stock levels',
      'Automated order emails and WhatsApp order notifications',
      'Multi-vendor marketplace platforms for multiple sellers',
      'Mobile-first shopping experience that actually converts',
    ],
    recentWorks: [
      {
        title: 'CeylonCrafts',
        client: 'Handcraft Seller — Sri Lanka',
        desc: 'Online store for handmade products with international shipping calculations and PayPal + card checkout.',
        tags: ['Shopify', 'Stripe', 'PayPal'],
      },
      {
        title: 'FreshMart Online',
        client: 'Grocery Store — Colombo',
        desc: 'Grocery e-commerce with same-day delivery zones, live product search, and WhatsApp order status updates.',
        tags: ['WooCommerce', 'Custom PHP', 'WhatsApp API'],
      },
      {
        title: 'FashionHub',
        client: 'Clothing Brand — Sri Lanka',
        desc: 'Fashion store with size guides, wishlist, product reviews, and loyalty points integration built in.',
        tags: ['Next.js', 'Stripe', 'Node.js'],
      },
    ],
  },

  'cybersecurity': {
    icon: <FaShieldAlt />,
    color: '#ef4444',
    title: 'Cybersecurity & Pentesting',
    tagline: 'Find the cracks before hackers do',
    description: `We test your website, app, or system for security vulnerabilities — the same way a real hacker would, but with your permission and for your protection. After testing, we give you a full written report detailing every issue we found, with a risk rating for each one. Then we fix them all. Your customers' data stays safe and your business reputation stays protected.`,
    images: [
      '/images/mockups/cyber1.svg',
      '/images/mockups/cyber2.svg',
    ],
    desktopImages: [
      '/images/mockups/cyber-d1.svg',
      '/images/mockups/cyber-d2.svg',
      '/images/mockups/cyber-d3.svg',
      '/images/mockups/cyber-d4.svg',
      '/images/mockups/cyber-d5.svg',
    ],
    whatWeDo: [
      'Web application penetration testing (OWASP Top 10 coverage)',
      'Mobile app security testing for Android and iOS',
      'Network and server vulnerability assessments',
      'Detailed security reports with clear risk ratings per issue',
      'Complete fixing and patching of every discovered vulnerability',
      'SSL setup, firewall configuration, and server hardening',
    ],
    recentWorks: [
      {
        title: 'Bank Portal Security Audit',
        client: 'Regional Bank — Sri Lanka',
        desc: 'Full penetration test of an online banking portal. Found and fully patched 14 critical vulnerabilities before any data was breached.',
        tags: ['Pentesting', 'OWASP', 'Fix & Report'],
      },
      {
        title: 'HealthApp Security Review',
        client: 'Healthcare App Provider',
        desc: 'Mobile application security assessment — discovered patient data exposure issues and patched them all before public launch.',
        tags: ['Android', 'iOS', 'API Security'],
      },
      {
        title: 'E-Commerce Security Hardening',
        client: 'Online Retailer — Sri Lanka',
        desc: 'Server hardening, firewall rules, and SSL implementation for an online store handling thousands of card payments.',
        tags: ['Server Hardening', 'SSL', 'Firewall'],
      },
    ],
  },
};

const ServicePage = ({ slug, onBack, onContact, division }) => {
  const service = serviceDetails[slug];
  const [lightboxIndex, setLightboxIndex] = useState(null);

  if (!service) return null;

  const images = service.images || [];
  const desktopImages = service.desktopImages || [];
  const allImages = [...images, ...desktopImages];
  const openLightbox = (i) => setLightboxIndex(i);
  const closeLightbox = () => setLightboxIndex(null);
  const prevImage = () => setLightboxIndex((lightboxIndex - 1 + allImages.length) % allImages.length);
  const nextImage = () => setLightboxIndex((lightboxIndex + 1) % allImages.length);

  return (
    <>
      <motion.div
        className="service-page"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      >
        {/* Back button */}
        <button className="service-page__back" onClick={onBack}>
          <FaArrowLeft />
          Back to Services
        </button>

        {/* Hero */}
        <div className="service-page__hero">
          <div
            className="service-page__hero-icon"
            style={{ background: `${service.color}18`, color: service.color, borderColor: `${service.color}33` }}
          >
            {service.icon}
          </div>
          <span className="service-page__tagline" style={{ color: service.color }}>
            {service.tagline}
          </span>
          <h1 className="service-page__title">{service.title}</h1>
          <p className="service-page__description">{service.description}</p>
        </div>

        {/* Divider */}
        <div className="service-page__divider" />

        {/* What we do */}
        <div className="service-page__section">
          <h2 className="service-page__section-title">What We Do For You</h2>
          <div className="service-page__features">
            {service.whatWeDo.map((item, i) => (
              <motion.div
                key={i}
                className="service-page__feature"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.1 + i * 0.07 }}
              >
                <FaCheckCircle className="service-page__feature-icon" style={{ color: service.color }} />
                <span className="service-page__feature-text">{item}</span>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Image Gallery — only when service has images */}
        {allImages.length > 0 && (
          <>
            <div className="service-page__divider" />
            <div className="service-page__section">
              <span className="service-page__works-label">
                {slug === 'loyalty-reward' ? 'App Screenshots' : 'Gallery'}
              </span>
              <h2 className="service-page__section-title">
                {slug === 'loyalty-reward' ? 'Inside the Loyalty App' : 'Recent Works We Did'}
              </h2>
              <p className="service-page__works-subtitle">
                {slug === 'loyalty-reward'
                  ? 'Real screenshots from our loyalty & reward system — customer app, QR code screens, points dashboard, and the admin panel.'
                  : 'Real layouts and screens from projects we recently built and delivered for our clients.'}
              </p>
              <div className="service-page__gallery">
                {images.map((src, i) => (
                  <motion.div
                    key={i}
                    className="service-page__gallery-item"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.35, delay: i * 0.03 }}
                    onClick={() => openLightbox(i)}
                  >
                    <div className="service-page__phone-frame">
                      <div className="service-page__phone-notch" />
                      <img
                        src={src}
                        alt={`App screenshot ${i + 1}`}
                        className="service-page__gallery-img"
                        loading="lazy"
                      />
                    </div>
                  </motion.div>
                ))}
              </div>

              {desktopImages.length > 0 && (
                <>
                  <p className="service-page__gallery-label">Desktop &amp; Web Dashboards</p>
                  <div className="service-page__gallery--desktop">
                    {desktopImages.map((src, i) => (
                      <motion.div
                        key={`d-${i}`}
                        className="service-page__gallery-item"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.35, delay: i * 0.04 }}
                        onClick={() => openLightbox(images.length + i)}
                      >
                        <div className="service-page__desktop-frame">
                          <div className="service-page__desktop-toolbar">
                            <span className="service-page__desktop-dot service-page__desktop-dot--red" />
                            <span className="service-page__desktop-dot service-page__desktop-dot--yellow" />
                            <span className="service-page__desktop-dot service-page__desktop-dot--green" />
                          </div>
                          <img
                            src={src}
                            alt={`Desktop screenshot ${i + 1}`}
                            className="service-page__gallery-img"
                            loading="lazy"
                          />
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </>
        )}

        {/* Divider */}
        <div className="service-page__divider" />

        {/* Recent Works */}
        <div className="service-page__section">
          <span className="service-page__works-label">Portfolio</span>
          <h2 className="service-page__section-title">Recent Works</h2>
          <p className="service-page__works-subtitle">
            Here are some of the projects we have delivered for our customers.
          </p>

          <div className="service-page__works-grid">
            {service.recentWorks.map((work, i) => (
              <motion.div
                key={i}
                className="service-page__work-card"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.15 + i * 0.12 }}
                style={{ '--work-color': service.color }}
              >
                <div className="service-page__work-number">0{i + 1}</div>
                <div
                  className="service-page__work-accent"
                  style={{ background: service.color }}
                />
                <h3 className="service-page__work-title">{work.title}</h3>
                <p className="service-page__work-client">{work.client}</p>
                <p className="service-page__work-desc">{work.desc}</p>
                <div className="service-page__work-tags">
                  {work.tags.map((tag, j) => (
                    <span
                      key={j}
                      className="service-page__work-tag"
                      style={{ color: service.color, borderColor: `${service.color}33`, background: `${service.color}12` }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <motion.div
          className="service-page__cta"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <h2 className="service-page__cta-title">Ready to start your project?</h2>
          <p className="service-page__cta-desc">
            Tell us what you need and we will get back to you within 24 hours.
          </p>
          <button
            className="service-page__cta-btn"
            style={{ background: service.color }}
            onClick={onContact}
          >
            Get in Touch
          </button>
        </motion.div>
      </motion.div>

      {/* Lightbox */}
      <AnimatePresence>
        {lightboxIndex !== null && (
          <motion.div
            className="service-page__lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeLightbox}
          >
            <button className="service-page__lb-close" onClick={closeLightbox}><FaTimes /></button>
            <button className="service-page__lb-nav service-page__lb-prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}><FaChevronLeft /></button>
            <motion.img
              key={lightboxIndex}
              src={allImages[lightboxIndex]}
              alt={`Screenshot ${lightboxIndex + 1}`}
              className="service-page__lb-img"
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.92 }}
              transition={{ duration: 0.25 }}
              onClick={(e) => e.stopPropagation()}
            />
            <button className="service-page__lb-nav service-page__lb-next" onClick={(e) => { e.stopPropagation(); nextImage(); }}><FaChevronRight /></button>
            <span className="service-page__lb-counter">{lightboxIndex + 1} / {allImages.length}</span>
          </motion.div>
        )}
      </AnimatePresence>

      <Contact division={division} />
      <Footer division={division} />
    </>
  );
};

export default ServicePage;
